import type { ComponentType, Dispatch, SetStateAction } from 'react'

export type FilterSelectOption = {
  text: string
  value: string
}

export type FilterOptionsResult = {
  options: FilterSelectOption[]
  isLoading?: boolean
}

export type FilterOptionsHook = (enabled: boolean) => FilterOptionsResult

type BaseFilterComponentProps = {
  name: string
  options?: FilterSelectOption[]
  setQueryString: Dispatch<SetStateAction<string>>
  queryString?: string
  openDatePicker?: string | null
  setOpenDatePicker?: Dispatch<SetStateAction<string | null>>
}

export interface FilterComponentProps extends BaseFilterComponentProps {
  value: string
}

export interface MultiValueFilterComponentProps
  extends BaseFilterComponentProps {
  value: string[]
}

export type FilterCategory = 'date' | 'origin' | 'dest'

export type AnyFilterComponentProps = BaseFilterComponentProps & {
  value: string | string[]
}

export type FilterConfig = {
  FilterComponent?: ComponentType<AnyFilterComponentProps>
  category?: FilterCategory
  label: string
  name: string
  options?: FilterSelectOption[]
  useOptions?: FilterOptionsHook
  relatedNames?: string[]
}

export const isMultiName = (name: string) => name.slice(-2) === '[]'

export const DATE_FILTER_NAMES = [
  'pickupDate',
  'deliveryDate',
  'bookedDate',
  'createdDate',
] as const

export const isDateFilter = (name: string): boolean =>
  (DATE_FILTER_NAMES as readonly string[]).includes(name)

export function getAllFilterNames(filter: FilterConfig): string[] {
  return [filter.name, ...(filter.relatedNames ?? [])]
}

export function hasFilterValues(
  filter: FilterConfig,
  params: URLSearchParams,
): boolean {
  return getAllFilterNames(filter).some(name => {
    if (isMultiName(name)) {
      return params.getAll(name).some(v => v !== '')
    }
    return Boolean(params.get(name))
  })
}
